import React from "react";
import DateRangePicker from "react-bootstrap-daterangepicker";
import * as moment from "moment";

const DateRangeFilter = ({ t, column: {filterValue, setFilter}}) => {

    const [valueApply, setValueApply] = React.useState("");

    const handleApply = (event, picker) => {
        const start = moment(picker.startDate).format("YYYY-MM-DD");
        const end = moment(picker.endDate).format("YYYY-MM-DD");
        setValueApply(`${start} - ${end}`);
        setFilter(`${start},${end}`);
    };

    const clearFilter = (e) => {
        e.stopPropagation();
        setValueApply("");
        setFilter(null)
    };

    return (

                <div className="input-group">
                    <div className="input-group-prepend">
                        <DateRangePicker onApply={handleApply}>
                            <button className="btn btn-outline-secondary" type="button">
                                <i className="fas fa-calendar"/>
                            </button>
                        </DateRangePicker>
                    </div>
                    <input type="text" className="form-control" placeholder="" value={valueApply} readOnly />
                    <div className="input-group-append">
                        <button className="btn btn-outline-danger" onClick={(e) => clearFilter(e)} type="button">
                            <i className="fas fa-times"/>
                        </button>
                    </div>
                </div>
    )
};
export default DateRangeFilter;
